import config from '../config';

export default {
  uploadAndProcessImage: `${config.baseApiUrl}/upload-and-process-image`,
  extractText: `${config.baseApiUrl}/extract-text/`,
  callLlmStructured: `${config.baseApiUrl}/call-llm-structured/`,
};
